import getEnvironDomain from "../utils/getEnvironDomain";
import strings from "../locales/strings";

const baseUrl = getEnvironDomain();

const footerLinks = {
  "add-truck": {
    iconName: "ic_truck-out",
    label: strings.menu_addTruck,
    href: `https://trucks.${baseUrl}/published?utm_source=header&utm_campaign=new_header`,
    code: "FOOTER_ADD_TRUCK",
  },
  "add-tender": {
    iconName: "ic_tender-out",
    label: strings.menu_addTenders,
    href: `https://${baseUrl}/tenders/add/?utm_source=header&utm_campaign=new_header`,
    code: "FOOTER_ADD_TENDER",
  },
  "add-truck-new": {
    iconName: "ic_truck-out",
    label: strings.menu_addTruck,
    href: `https://trucks.${baseUrl}/trucks/create?utm_source=header&utm_campaign=new_header`,
    code: "FOOTER_ADD_TRUCK_NEW",
  },
  "add-order": {
    iconName: "ic_orders-to-you-out",
    label: strings.menu_add_order,
    href: `https://loads.${baseUrl}/orders/application/create?utm_source=header&utm_campaign=new_header`,
    code: "FOOTER_ADD_ORDER",
  },
  billing: {
    iconName: "ic_wallet-out",
    label: strings.menu_billing,
    // utm метки для этой ссылки проставляются в компоненте <Footer>
    href: `https://billing.${baseUrl}/addinvoice`,
    code: "FOOTER_BILLING",
  },
  "create-board": {
    iconName: "ic_open-board-out",
    label: strings.menu_createBoard,
    href: `https://${baseUrl}/boards/welcome/add/loads?utm_source=header&utm_campaign=new_header`,
    code: "FOOTER_CREATE_BOARD",
  },
  "add-load": {
    iconName: "ic_cargo-out",
    label: strings.menu_addLoad,
    href: `https://loads.${baseUrl}/cargos/create?utm_source=header&utm_campaign=new_header`,
    code: "FOOTER_ADD_LOAD",
  },
};

export default footerLinks;
